import { Box, Grid, Typography } from '@mui/material'
import { useAuth } from 'contexts/auth'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useStyles } from './styles'

type FileType = 'principal' | 'branco' | 'preto'

const PreviewTheme: React.FC<{}> = () => {
  const { user } = useAuth()
  const classes = useStyles()
  const history = useHistory()

  const themeNotExist = user == null || user.theme == undefined || user.theme === null

  useEffect(() => {
    if (themeNotExist) {
      history.push('/themes/configure')
    }
  }, [themeNotExist])

  if (themeNotExist) {
    return null
  }

  const userThemeColor = {
    primary: user.theme!.primary.includes('#') ? user.theme!.primary : `#${user.theme!.primary}`,
    secondary: user.theme!.secondary.includes('#') ? user.theme!.secondary : `#${user.theme!.secondary}`,
    terciary: user.theme!.terciary.includes('#') ? user.theme!.terciary : `#${user.theme!.terciary}`,
  }

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Typography
          variant='h6'
          sx={{ margin: '1rem 0' }}
        >
          Logos
        </Typography>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={4}
          >
            <UploadBox
              type='principal'
              preview={user.theme!.baseLogo}
            />
          </Grid>
          <Grid
            item
            xs={4}
          >
            <UploadBox
              type='branco'
              preview={user.theme!.whiteLogo}
            />
          </Grid>
          <Grid
            item
            xs={4}
          >
            <UploadBox
              type='preto'
              preview={user.theme!.blackLogo}
            />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ width: '100%' }}>
        <Typography
          variant='h6'
          sx={{ margin: '1rem 0' }}
        >
          Cores
        </Typography>

        <Grid
          container
          className={classes.itemBox}
        >
          <Grid
            item
            xs={4}
          >
            <Box
              className={classes.colorBox}
              bgcolor={userThemeColor.primary}
            />
            <span>Primaria</span>
          </Grid>
          <Grid
            item
            xs={4}
          >
            <Box
              className={classes.colorBox}
              bgcolor={userThemeColor.secondary}
            />
            <span>Secundaria</span>
          </Grid>
          <Grid
            item
            xs={4}
          >
            <Box
              className={classes.colorBox}
              bgcolor={userThemeColor.terciary}
            />
            <span>Terciária</span>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

interface UploadBoxProps {
  type: FileType
  preview: string
}

const UploadBox: React.FC<UploadBoxProps> = ({ preview, type }) => {
  const classes = useStyles()

  const havePreviewClassName = (preview: null | string, type: FileType) => {
    if (preview == null) {
      return classes.formBox
    }

    if (type === 'branco') {
      return classes.formBoxWhite
    }

    return classes.formBoxBase
  }

  if (preview != null) {
    const previewSplitted = preview.split('/')
    const previewExtension = previewSplitted[previewSplitted.length - 1]

    if (previewExtension == '') {
      preview = ''
    }
  }

  return (
    <Box
      sx={{ cursor: preview == null ? 'pointer' : 'default' }}
      className={havePreviewClassName(preview, type)}
    >
      {preview && (
        <img
          src={preview}
          alt='logo'
        />
      )}
    </Box>
  )
}

export default PreviewTheme
